import EFPicture from 'elem/compCommon/EFPicture';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function A() {
    const { useLang } = useGlobal();
    const { t } = useLang('camp');
    return (
        <div className={`camp-A camp-box ${css['camp-A']}`}>
            <h1 className="title main">{t('secA_title')}</h1>
            <div className="img-box">
                <EFPicture src={'/responsive/picture/camp/1.jpg'} alt={t('secA_title')} />
            </div>
            <div className="text-box">
                <h2 className="text">{t('secA_text')}</h2>
                <p className="desc black">{t('secA_desc')}</p>
            </div>
        </div>
    );
}
